// Libraries
import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
  PreloadAllModules
} from '@angular/router';

// Components
import { NoContentComponent } from './no-content.component';

/**
 * Routes for app module.
 */
const MAIN_ROUTES: Routes = [
  { path: '**', component: NoContentComponent }
];

/**
 * `AppRoutingModule` defines the main routes.
 */
@NgModule({
  imports: [
    RouterModule.forRoot(MAIN_ROUTES, { useHash: true, preloadingStrategy: PreloadAllModules })
  ],
  exports: [
    RouterModule
  ],
  providers: [
  ]
})
export class AppRoutingModule { }

/**
 * Routing components.
 */
export const routingComponents = [NoContentComponent];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app.routing.ts